// German for the ENGAGEMENTS zone: one card per engagement — position, gate tally, route grid.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Engagements': 'Aufträge',
  '{n} active': '{n} aktiv',
  'none active': 'keine aktiv',
  '{n} archived': '{n} archiviert',
  'New engagement': 'Neuer Auftrag',
  'No engagement on this client yet — so no phase, no gate, and nothing on this page claims one.': 'Noch kein Auftrag bei diesem Kunden — also keine Phase, kein Gate, und nichts auf dieser Seite behauptet eines.',
  'archived {date}': 'archiviert {date}',
  '{currency} estimate': 'Schätzung {currency}',
  'kickoff': 'Kickoff',
  'phase': 'Phase',
  'of': 'von',
  'no gate': 'kein Gate',
  'Open {code}': '{code} öffnen',
  'gate engine did not answer': 'Gate-Engine hat nicht geantwortet',
  'tally not evaluable': 'Stand nicht auswertbar',
  'Lifecycle': 'Lebenszyklus',
  'automatic': 'automatisch',
  'manual': 'manuell',
  'No gate was evaluated for this engagement.': 'Für diesen Auftrag wurde kein Gate ausgewertet.',
  'gate not evaluable': 'Gate nicht auswertbar',
  // ROUTE_LABEL — the six cells of the route grid
  'Documents': 'Dokumente',
  'Register': 'Register',
  'Agent': 'Agent',
  'Proposals': 'Vorschläge',
  'Contracting': 'Vertrag',
  'Acceptance': 'Abnahme',
}, 'ClientEngagementCards');
